import styled from "styled-components";

export const AdLink = styled.a``;

export const AdImg = styled.img`
    display: block;
`;
